// =============================================================================
// ColorPicker.jsx - Color Picker Component
// =============================================================================
// Simple color picker component using native HTML5 color input
// =============================================================================

import React from 'react';

export const ColorPicker = ({ color, onChange, disabled = false }) => {
  return (
    <div style={{
      position: 'relative',
      display: 'inline-block'
    }}>
      <input
        type="color"
        value={color || '#FF0000'}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        style={{
          width: '50px',
          height: '32px',
          border: '1px solid #d1d5db',
          borderRadius: '6px',
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.6 : 1,
          padding: '2px'
        }}
      />
    </div>
  );
};

export default ColorPicker;
